export default __webpack_public_path__ + "static/media/030-measuring tape.e9b06cec.svg";